module.exports = __webpack_public_path__ + "bca1785eb69f92247451044c1c1f2c1d.svg";